import jwtDecode from "jwt-decode"

export const isAccessTokenExpired = (accessToken: string) =>
  jwtDecode<{ exp: number }>(accessToken).exp - Date.now() / 1000 < 5 // refresh the token 5 seconds before expiration
